import { Constants } from '@leverege/api-redux';
import { cleanupPreload } from "../../preload.js";
export default {
  id: 'molten.cleanupPreload',
  sort: Infinity,
  onLoggedIn: molten => {
    // Create the opts for api. 
    cleanupPreload();
  },
  createMiddleware: molten => {
    return store => next => action => {
      if (action.type === Constants.AUTH_VERIFY_FAILED) {
        cleanupPreload();
      }
      next(action);
    };
  }
};